import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { AttachmentResponseViewModel } from 'types/appointment';
import Stack from '@mui/material/Stack';
import { AttachmentsView } from 'components/@shared/Attachments';

interface Props {
    title: string;
    attachments: AttachmentResponseViewModel[];
}

export const AppointmentDetailsAttachments = ({ title, attachments }: Props) => (
    <Grid container>
        <Grid item xs={4} lg={3}>
            <Typography fontWeight={500}>{title}</Typography>
        </Grid>
        <Grid item xs={8} lg={9}>
            <Stack gap={1}>
                {attachments.length === 0 && <Typography>none</Typography>}
                <AttachmentsView list={attachments} />
            </Stack>
        </Grid>
    </Grid>
);
